import { ShoppingCart, Plus, Minus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatCurrency } from "@/lib/currencyFormatter";

interface CartItemProps {
  id: string;
  menuItemName: string;
  price: number;
  quantity: number;
  imageUrl?: string;
  updateQuantity: (id: string, delta: number) => void;
  removeItem: (id: string) => void;
}

export function CartItem({
  id,
  menuItemName,
  price,
  quantity,
  imageUrl,
  updateQuantity,
  removeItem,
}: CartItemProps) {
  return (
    <div className="flex items-start p-4 gap-3">
      {imageUrl && (
        <div className="w-16 h-16 rounded overflow-hidden flex-shrink-0">
          <img
            src={imageUrl}
            alt={menuItemName}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="flex-grow">
        <h4 className="font-medium">{menuItemName}</h4>
        <p className="text-sm text-muted-foreground">
          {formatCurrency(price)} each
        </p>
      </div>
      <div className="flex flex-col items-end">
        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="icon"
            className="w-8 h-8 rounded-full"
            onClick={() => updateQuantity(id, -1)}
          >
            <Minus className="w-4 h-4" />
          </Button>
          <span className="w-6 text-center font-medium">{quantity}</span>
          <Button
            variant="outline"
            size="icon"
            className="w-8 h-8 rounded-full"
            onClick={() => updateQuantity(id, 1)}
          >
            <Plus className="w-4 h-4" />
          </Button>
        </div>
        <div className="flex items-center gap-2 mt-2">
          <span className="font-medium">
            {formatCurrency(price * quantity)}
          </span>
          <Button
            variant="ghost"
            size="icon"
            className="w-6 h-6 text-destructive"
            onClick={() => removeItem(id)}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
